import { Link, useLocation } from 'react-router';
import { useSnapshot } from 'valtio';

import * as userStore from '@cartwhl/common/stores/userStore';
import AnimatedLogo from '@cartwhl/ui/atoms/AnimatedLogo';
import ClientBrand from '@cartwhl/ui/organisms/ClientBrand';
import UserMenuWithCredits from '@cartwhl/ui/organisms/UserMenuWithCredits';

/** App dashboard shell: animated wordmark + account menu (no marketing nav). */
export default function AppShellHeader() {
  const { pathname } = useLocation();
  const { theme, clientSlug, organizationInfo, loading } = useSnapshot(
    userStore.state,
  );
  return (
    <header className="bg-primary border-primary sticky top-0 z-50 flex w-full flex-col border-b">
      <div className="flex h-16 min-w-0 items-center justify-between gap-2 px-4 sm:px-6 lg:px-10">
        <div className="flex min-w-0 items-center gap-3 sm:gap-5">
          <Link
            to="/"
            aria-label="Cartwheel home"
            className="text-primary inline-flex shrink-0 items-center"
          >
            <span aria-hidden="true">
              <AnimatedLogo
                className="w-[144px] sm:w-[151px]"
                color={theme === 'dark' ? 'text-white' : 'text-gray-90'}
              />
            </span>
          </Link>
          {!loading && (
            <ClientBrand
              key={clientSlug}
              clientSlug={clientSlug}
              companyName={organizationInfo?.organizationName}
            />
          )}
        </div>
        <UserMenuWithCredits
          currentPathname={pathname}
          currentSurface="apps"
          appletHeader
        />
      </div>
    </header>
  );
}
